module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-select"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('float-label', {
    staticClass: "select-wrapper",
    attrs: {
      "label": _vm.question.content
    }
  }, [_c('select', {
    staticClass: "form-group__select",
    on: {
      "change": function($event) {
        return _vm.setAnswer($event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v(_vm._s(_vm.question.content))]), _vm._l((_vm.question.options), function(country, key) {
    return _c('option', {
      domProps: {
        "selected": key === _vm.question.answer,
        "value": key
      }
    }, [_vm._v(_vm._s(country))])
  })], 2)]), (_vm.question.info) ? _c('div', {
    staticClass: "question-caption mt-15 pb-15"
  }, [_c('div', {
    staticClass: "question-caption__content",
    domProps: {
      "innerHTML": _vm._s(_vm.question.info)
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00a3e06f","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-select.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-00a3e06f","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/question-select.vue
// module chunks = 0